import React from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../images/recipeailogo.jpg";
import { useSubscription } from "../context/SubscriptionContext";

const Header = ({ title = "Admin Dashboard" }) => {
  const { isSubscribed } = useSubscription();
  const navigate = useNavigate();

  return (
    <header className="mobile-app-header px-3 shadow-xs">
      <div className="d-flex justify-content-between align-items-center w-100">
        <div className="d-flex align-items-center gap-2">
          <button
            type="button"
            className="btn btn-sm btn-light rounded-circle shadow-xs border d-flex align-items-center justify-content-center"
            style={{ width: "34px", height: "34px" }}
            onClick={() => navigate("/")}
            title="Back to App"
          >
            <i className="fi fi-rr-angle-left" style={{ fontSize: "14px" }}></i>
          </button>
          <div className="d-flex align-items-center gap-2">
            <h1 className="h6 mb-0 fw-bold text-dark text-nowrap" style={{ letterSpacing: "-0.2px" }}>
              {title}
            </h1>
            <span
              className="badge rounded-pill px-2 py-0.5 fw-bold"
              style={{
                fontSize: "10px",
                background: "rgba(34, 197, 94, 0.14)",
                color: "#15803d",
                border: "1px solid rgba(34, 197, 94, 0.3)"
              }}
            >
              Admin
            </span>
          </div>
        </div>

        <div className="d-flex align-items-center gap-2">
          <Link to="/" className="btn btn-sm btn-outline-success rounded-pill px-2.5 py-0.5" style={{ fontSize: "11px", fontWeight: "600" }}>
            <i className="fi fi-rr-arrow-right-from-bracket me-1"></i> Exit Admin
          </Link>
          <img
            src={logo}
            alt="Logo"
            className="rounded-circle shadow-xs"
            width="32"
            height="32"
            style={{ objectFit: "cover", border: "1.5px solid #22c55e" }}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
